import Vue from 'vue';
import kebabCase from 'lodash/kebabCase';

const requireComponent = require.context('.', false, /Modal\.vue$/);
requireComponent.keys().forEach((name) => {
    let component = requireComponent(name);
    name = kebabCase(name.replace(/^\.\/(.*)Modal\.\w+$/, '$1'));
    Vue.$modal.register(name, component.default || component);
});